module.exports = __webpack_public_path__ + "img/16.5e8ccacc.jpg";